import * as React from 'react';
import { EventBus } from '@/shared/utils';
import { ChangePasswordEventKeys, ChangePasswordEvents } from '../events';
import { Changepassword } from '@/shared/i18n';
import { ChangePasswordForm } from '../ui/change-password-form';
import { useUpdatePassword } from '../hooks/use-update-password';
import UpdatePasswordFeedback from '../ui/elements/action-feedback';
import { Auth } from 'firebase/auth';

interface ChangePasswordScreenProps {
  auth: Auth;
  eventBus: EventBus<ChangePasswordEvents>;
  dict: Changepassword;
}

const ChangePasswordScreen: React.FC<ChangePasswordScreenProps> = ({ auth, dict, eventBus }) => {
  const { updatePassword } = useUpdatePassword(auth, dict, eventBus);

  React.useEffect(() => {
    eventBus.on(ChangePasswordEventKeys.changePassword.update, updatePassword);

    return () => {
      eventBus.off(ChangePasswordEventKeys.changePassword.update, updatePassword);
    };
  }, [eventBus, updatePassword]);

  return (
    <>
      <UpdatePasswordFeedback />
      <ChangePasswordForm dict={dict} eventBus={eventBus} />
    </>
  );
};

export default ChangePasswordScreen;
